/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Threshold_HelpInputs */



/**
* | output |
* | --- |
* | "Volume level that triggers ducking (lower = more sensitive)" |
*
* @param {Audio_Description_Export_Automix_Threshold_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_threshold_help = /** @type {((inputs?: Audio_Description_Export_Automix_Threshold_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Threshold_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Niveau de volume qui déclenche l'atténuation (plus bas = plus sensible)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lautstärkepegel, der das Ducking auslöst (niedriger = empfindlicher)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Livello del volume che attiva il ducking (più basso = più sensibile)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Уровень громкости, запускающий эффект приглушения (чем ниже уровень, тем выше чувствительность).")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nivel de volumen que activa el ducking (más bajo = más sensible)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("触发闪避的音量级别（越低越敏感）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ダッキングをトリガーする音量レベル（低いほど感度が高い）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आवाज का वह स्तर जो झुकने को प्रेरित करता है (कम आवाज = अधिक संवेदनशीलता)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nível de volume que aciona o mecanismo de abaixamento (menor = maior sensibilidade)")
	return /** @type {LocalizedString} */ ("Volume level that triggers ducking (lower = more sensitive)")
});